import styled, { FlattenSimpleInterpolation } from 'styled-components';

export default styled.div<{ extraStyle?: FlattenSimpleInterpolation }>`
  display: flex;
  flex-wrap: wrap;
  ${({ extraStyle }): FlattenSimpleInterpolation | undefined => extraStyle};
`;
